import React, { useEffect, useState } from 'react';

import { Hit } from '@algolia/client-search';
import { collection, getDocs, query } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { FaToolbox, FaTools } from 'react-icons/fa';

import somosJoLogo from 'assets/somosjo.webp';
import { useSearch } from 'hooks/search';
import Category from 'interfaces/Category';
import Service from 'interfaces/Service';
import { client } from 'services/algoliasearch';
import { db } from 'services/firebase';

import AutoCompleteSearch from './AutoCompleteSearch';
import SearchResults from './SearchResults';
import { Container, SearchBox, SearchBoxHeader } from './styles';

const Home: React.FC = () => {
  const { selectedSearch, clearSearch } = useSearch();

  const [readableCategoryNames, setReadableCategoryNames] = useState<string[]>(
    [],
  );
  const [searchIsFocused, setSearchIsFocused] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [hasSearched, setHasSearched] = useState(false);
  const [queryID, setQueryID] = useState<string>();

  const [loading, setLoading] = useState(false);
  const [searchResults, setSearchResults] = useState<Array<Hit<Service>>>([]);

  useEffect(() => {
    const loadServiceCategories = async (): Promise<void> => {
      const q = query(collection(db, `/categories`));
      const categoriesSnapshot = await getDocs(q);
      const readableNames = categoriesSnapshot.docs.map(
        (document) => (document.data() as Category).readableName,
      );

      setReadableCategoryNames(readableNames);
    };
    loadServiceCategories();
  }, []);

  useEffect(() => {
    if (selectedSearch) {
      setHasSearched(true);
      setSearchText(selectedSearch.searchTerm);
    }
  }, [selectedSearch, setHasSearched, setSearchResults]);

  useEffect(() => {
    const executeSearch = (): void => {
      if (!searchText || searchText.trim() === '') {
        return;
      }

      setLoading(true);

      client
        .initIndex('circle_services')
        .search(searchText, { clickAnalytics: true, timeout: 3000 })
        .then((response) => {
          const hits = response.hits as Array<Hit<Service>>;
          const { queryID: id } = response;

          setQueryID(id);
          setSearchResults(hits.filter((hit) => !hit.excluded));
        })
        .catch((err) => {
          toast.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    };

    executeSearch();
  }, [searchText]);

  useEffect(() => {
    if (searchText === '') {
      setLoading(false);
    } else {
      setHasSearched(true);
    }
  }, [searchText, selectedSearch, setLoading, clearSearch]);

  return (
    <Container>
      <SearchBox hasSearched={hasSearched}>
        {!hasSearched && !searchIsFocused && (
          <img
            width={200}
            src={somosJoLogo}
            alt="Somos JO"
            style={{
              filter:
                'invert(89%) sepia(100%) saturate(0%) hue-rotate(61deg) brightness(1185%) contrast(9148%)',
            }}
          />
        )}
        <SearchBoxHeader>
          <FaTools color="#fff" size={40} />
          <h1>Classificados</h1>
          <FaToolbox color="#fff" size={40} />
        </SearchBoxHeader>
        <AutoCompleteSearch
          suggestions={readableCategoryNames}
          setSearchIsFocused={setSearchIsFocused}
          setSearchText={setSearchText}
        />
      </SearchBox>
      <SearchResults
        queryID={queryID}
        searchText={searchText}
        hasSearched={hasSearched}
        loading={loading}
        searchResults={searchResults}
      />
    </Container>
  );
};

export default Home;
